import { render, staticRenderFns } from "./CmgSustainabilityStatsPageLink.vue?vue&type=template&id=522ecf6d&scoped=true&lang=pug"
import script from "./cmg-sustainability-stats-page-link.ts?vue&type=script&lang=ts&external"
export * from "./cmg-sustainability-stats-page-link.ts?vue&type=script&lang=ts&external"
import style0 from "./CmgSustainabilityStatsPageLink.vue?vue&type=style&index=0&id=522ecf6d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "522ecf6d",
  null
  
)

export default component.exports